import React, { useState } from 'react';
import Header from './Header';
import ProgressBar from './ProgressBar';
import Instructions from './Instructions';
import Question from './Question';
import Results from './Results';
import { questions, elementInfo } from '../data/assessmentData';
const Assessment = () => {
  const [currentAnswers, setCurrentAnswers] = useState<Record<number, string>>({});
  const [showResults, setShowResults] = useState(false);
  const [results, setResults] = useState<{
    scores: Record<string, number>;
    percentages: Record<string, number>;
    dominantElement: string;
  } | null>(null);
  const selectOption = (questionId: number, element: string) => {
    setCurrentAnswers(prev => ({
      ...prev,
      [questionId]: element
    }));
  };
  const calculateResults = () => {
    const scores: Record<string, number> = {
      wood: 0,
      fire: 0,
      earth: 0,
      metal: 0,
      water: 0
    };
    // Count scores for each element
    Object.values(currentAnswers).forEach(element => {
      scores[element]++;
    });
    // Calculate percentages
    const totalQuestions = questions.length;
    const percentages: Record<string, number> = {};
    Object.keys(scores).forEach(element => {
      percentages[element] = Math.round(scores[element] / totalQuestions * 100);
    });
    // Sort elements by score
    const sortedElements = Object.keys(scores).sort((a, b) => scores[b] - scores[a]);
    const dominantElement = sortedElements[0];
    setResults({
      scores,
      percentages,
      dominantElement
    });
    setShowResults(true);
    // Scroll to results after a brief delay to allow rendering
    setTimeout(() => {
      const resultsElement = document.getElementById('results');
      if (resultsElement) {
        resultsElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, 100);
  };
  const answeredQuestionsCount = Object.keys(currentAnswers).length;
  const totalQuestionsCount = questions.length;
  const progressPercentage = answeredQuestionsCount / totalQuestionsCount * 100;
  return <div className="max-w-4xl mx-auto bg-white/95 rounded-3xl shadow-2xl overflow-hidden" data-id="element-6">
      <Header data-id="element-7" />
      <ProgressBar progress={progressPercentage} answeredQuestions={answeredQuestionsCount} totalQuestions={totalQuestionsCount} data-id="element-8" />
      <div className="p-6 md:p-10" data-id="element-9">
        <Instructions data-id="element-10" />
        {questions.map(question => <Question key={question.id} question={question} selectedElement={currentAnswers[question.id]} onSelect={selectOption} data-id="element-11" />)}
        <button type="button" onClick={calculateResults} disabled={answeredQuestionsCount < totalQuestionsCount} className="mt-8 mb-4 bg-gradient-to-r from-indigo-500 to-purple-600 text-white py-4 px-10 rounded-full text-lg font-semibold shadow-lg hover:translate-y-[-2px] hover:shadow-xl transition-all disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:translate-y-0 disabled:hover:shadow-lg block mx-auto" data-id="element-12">
          {answeredQuestionsCount === totalQuestionsCount ? '🔮 Calculate My Five-Element Type' : `Please answer ${totalQuestionsCount - answeredQuestionsCount} more questions`}
        </button>
        {showResults && results && <Results id="results" scores={results.scores} percentages={results.percentages} dominantElement={results.dominantElement} data-id="element-13" />}
      </div>
    </div>;
};
export default Assessment;